import React, { Component } from 'react';
import homeIcon from '../images/home.png';

class MapControls extends Component {
    constructor(props){
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler (e){
        let id = e.currentTarget.id, 
            map = this.props.map;

        if(id === 'satelite'){
            map.setLayoutProperty('uaeu-raster', 'visibility', 'visible');
            this.props.setMapStyle('satelite');
        } else if(id === 'vmap'){
            map.setLayoutProperty('uaeu-raster', 'visibility', 'none');            
            this.props.setMapStyle('basic');
        }else{
            map.flyTo({
                center: [55.67900, 24.19760],
                speed: 0.5,
                zoom: 15
            });
        }

    }
    
    showDirection(e){
        this.props.setDirection(this.props.mapDirection ? false : true);
        this.props.menuToggle(!this.props.mapDirection ? false : true);       

        if(this.props.mapDirection === true && this.props.map.getLayer('dir')){
            this.props.map.setLayoutProperty('dir', 'visibility' , 'none');
            this.props.map.setLayoutProperty('uaeu-start', 'visibility' , 'none');
            this.props.map.setLayoutProperty('uaeu-end', 'visibility' , 'none');


        }
    }
    render(){
        return(
            <ul className="no-list" id="map-styles" aria-label="Map controls">
                <li>
                    <button type="button" id="home" aria-label="Reset map view" title="Reset map view" onClick={this.clickHandler}>
                        <img src={homeIcon} alt="" aria-hidden="true" />
                    </button>
                </li>
                <li><button type="button" id="vmap" className={this.props.mapStyle === 'basic' ? 'active' : ''} aria-pressed={this.props.mapStyle === 'basic'} onClick={this.clickHandler}>Map</button></li>
                <li><button type="button" id="satelite" className={this.props.mapStyle === 'satelite' ? 'active' : ''} aria-pressed={this.props.mapStyle === 'satelite'} onClick={this.clickHandler}>Satelite</button></li>
                <li><button type="button" className={this.props.mapDirection ? 'active' : ''} aria-pressed={this.props.mapDirection} onClick={this.showDirection.bind(this)}>Directions</button></li>
            </ul>
        )
    }
}

export default MapControls;



// WEBPACK FOOTER //
// ./src/components/MapControls.js